import styled from '@emotion/styled';
import { useTranslation } from '@kc-console/core';
import { IcGridRegular } from '@kep/kcds-icons';

import { useMegaMenuState } from '../../../hooks';
import { TooltipServiceButton } from './ServiceButton';

const AllServiceSection = () => {
  const { t } = useTranslation();
  const { isOpen, setIsOpen } = useMegaMenuState();

  return (
    <AllServiceSectionWrapper>
      <AllServiceButton
        message={t('layout:mega_menu.header.all_services.tooltip')}
        onClick={e => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        startIcon={<IcGridRegular />}
      >
        {t('layout:mega_menu.header.all_services')}
      </AllServiceButton>
      <Bar />
    </AllServiceSectionWrapper>
  );
};

export default AllServiceSection;

const AllServiceSectionWrapper = styled('li')`
  display: flex;
  align-items: center;
`;

const AllServiceButton = styled(TooltipServiceButton)`
  padding: 11px 16px;
  white-space: nowrap;
`;

const Bar = styled('div')`
  width: 1px;
  height: 16px;
  background: ${({ theme }) => theme.color['border/global/strong/default']};
`;
